import { createRouter, createWebHistory } from 'vue-router'
import Loader from '../views/Loader.vue'
import Office from '../views/Office.vue'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: Loader,
      meta: {
        title: 'Milo Barré - Portfolio',
        metaTags: [
          {
            rel: 'canonical',
            href: 'https://milobarre.me'
          },
          {
            name: 'title',
            content: 'Milo Barré - Portfolio'
          },
          {
            name: 'description',
            content:
              "Découvrez le portfolio de Milo Barré, étudiant en Création et Design et passionné d'informatique et de design !"
          },
          {
            name: 'keywords',
            content: 'portfolio, paul jaguin, développeur web, full stack, sites web, applications web, applications mobiles, JS, PHP, SQL, ORM, frameworks, DevOps'
          },
          {
            name: 'author',
            content: 'Paul Jaguin'
          },
          {
            name: 'robots',
            content: 'index, follow'
          },
          {
            name: 'theme-color',
            content: '#000000'
          },
          {
            name: 'mobile-web-app-capable',
            content: 'yes'
          },
          {
            name: 'apple-mobile-web-app-status-bar-style',
            content: 'black'
          },
          {
            name: 'apple-mobile-web-app-title',
            content: 'Milo Barré - Portfolio'
          },
          {
            name: 'application-name',
            content: 'Milo Barré - Portfolio'
          },
          {
            name: 'twitter:card',
            content: 'summary'
          },
          {
            name: 'twitter:title',
            content: 'Milo Barré - Portfolio'
          },
          {
            name: 'twitter:description',
            content:
              "Découvrez le portfolio de Milo Barré, étudiant en Création et Design et passionné d'informatique et de design !"
          },
          {
            name: 'twitter:image',
            content: 'https://pauljaguin.com/img/logo-portfolio-black.webp'
          },
          {
            name: 'twitter:image:alt',
            content: 'Logo Portfolio Paul Jaguin'
          },
          {
            property: 'og:type',
            content: 'website'
          },
          {
            property: 'og:title',
            content: 'Milo Barré - Portfolio'
          },
          {
            property: 'og:description',
            content:
              "Découvrez le portfolio de Milo Barré, étudiant en Création et Design et passionné d'informatique et de design !"
          },
          {
            property: 'og:site_name',
            content: 'Milo Barré - Portfolio'
          },
          {
            property: 'og:url',
            content: 'https://pauljaguin.com'
          },
          {
            property: 'og:image',
            content: 'https://pauljaguin.com/img/logo-portfolio-black.webp'
          },
          {
            property: 'og:image:alt',
            content: 'Logo Portfolio Milo Barré'
          },
          {
            property: 'og:locale',
            content: 'fr_FR'
          },
          {
            property: 'og:locale:alternate',
            content: 'en_US'
          }
        ]
      }
    },
    {
      path: '/office',
      name: 'Office',
      component: Office,
      meta: {
        title: 'Milo Barré - Portfolio',
        metaTags: [
          {
            rel: 'canonical',
            href: 'https://milobarre.me/office'
          },
          {
            name: 'title',
            content: 'Bureau | Milo Barré - Étudiant Création Design'
          },
          {
            name: 'description',
            content:
              "Découvrez le portfolio de Milo Barré, étudiant en Création et Design et passionné d'informatique et de design !"
          },
          {
            name: 'keywords',
            content: 'bureau, paul jaguin, développeur web, full stack, sites web, applications web, applications mobiles, JS, PHP, SQL, ORM, frameworks, DevOps'
          },
          {
            name: 'author',
            content: 'Milo Barré'
          },
          {
            name: 'robots',
            content: 'index, follow'
          },
          {
            name: 'theme-color',
            content: '#000000'
          },
          {
            name: 'mobile-web-app-capable',
            content: 'yes'
          },
          {
            name: 'apple-mobile-web-app-status-bar-style',
            content: 'black'
          },
          {
            name: 'apple-mobile-web-app-title',
            content: 'Milo Barré - Portfolio'
          },
          {
            name: 'application-name',
            content: 'Milo Barré - Portfolio'
          },
          {
            name: 'twitter:card',
            content: 'summary'
          },
          {
            name: 'twitter:title',
            content: 'Milo Barré - Portfolio'
          },
          {
            name: 'twitter:description',
            content:
              "Découvrez le portfolio de Milo Barré, étudiant en Création et Design et passionné d'informatique et de design !"
          },
          {
            name: 'twitter:image',
            content: 'https://pauljaguin.com/img/logo-portfolio-black.webp'
          },
          {
            name: 'twitter:image:alt',
            content: 'Logo Portfolio Paul Jaguin'
          },
          {
            name: 'og:type',
            content: 'website'
          },
          {
            name: 'og:title',
            content: 'Milo Barré - Portfolio'
          },
          {
            name: 'og:description',
            content:
              "Découvrez le portfolio de Milo Barré, étudiant en Création et Design et passionné d'informatique et de design !"
          },
          {
            name: 'og:site_name',
            content: 'Milo Barré - Portfolio'
          },
          {
            name: 'og:url',
            content: 'https://pauljaguin.com/office'
          },
          {
            name: 'og:image',
            content: 'https://pauljaguin.com/img/logo-portfolio-black.webp'
          },
          {
            name: 'og:image:alt',
            content: 'Logo Portfolio Paul Jaguin'
          },
          {
            name: 'og:locale',
            content: 'fr_FR'
          },
          {
            name: 'og:locale:alternate',
            content: 'en_US'
          }
        ]
      }
    }
  ]
})

export default router
